import { Component, inject } from '@angular/core';
import { NativeRouterService } from '@inshared/shared/util';
import { NewModalModule, NewModalRef } from 'outshared-lib';
import { WucButtonModule, WucIconUiModule, WucLinkModule, WucListModule } from '@inshared/website-ui-components';
import { genericButtonTexts } from '@inshared/shared/core';
import { NgForOf } from '@angular/common';

@Component({
    standalone: true,
    selector: 'ins-logout-modal',
    templateUrl: './logout.modal.html',
    imports: [
        NewModalModule,
        WucButtonModule,
        WucIconUiModule,
        WucListModule,
        WucLinkModule,
        NgForOf
    ]
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class LogoutModal {
    public baseUrl = inject(NativeRouterService).baseUrl;
    public advantages: string[] = $localize`:@@authentication.logout.advantages:Immediate insight into your insurance|Easily add insurance|Quickly report damage`.split('|');

    constructor(private modal: NewModalRef<LogoutModal>) {}

    public cancel(): void {
        this.modal.close();
    }

    public logout(): void {
        this.modal.close(true);
    }

    protected readonly genericButtonTexts = genericButtonTexts;
}
